
import { Suspense } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Programs from './components/Programs';
import SeasonInfo from './components/SeasonInfo';
import UpcomingEvents from './components/UpcomingEvents';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://www.cherokeeyouthwarriors.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'SportsOrganization',
  name: 'Cherokee Youth Football & Cheer',
  alternateName: 'Cherokee Warriors',
  url: siteUrl,
  description:
    'Cherokee Youth Football & Cheer in Canton, GA offers K-5 football and cheerleading programs. Join the Warriors family and build character, teamwork, and lifelong memories through youth sports.',
  sport: ['American Football', 'Cheerleading'],
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Canton',
    addressRegion: 'GA',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 34.2368,
    longitude: -84.4908,
  },
  areaServed: {
    '@type': 'City',
    name: 'Canton',
    containedInPlace: {
      '@type': 'State',
      name: 'Georgia',
    },
  },
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@cherokeeyouth.com',
    contactType: 'customer support',
  },
};

export default function HomePage() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-white" />}>
      <SeoHead
        title="Cherokee Youth Football & Cheer Canton GA | Warriors K-5 Program"
        description="Cherokee Youth Football & Cheer in Canton, GA offers K-5 football and cheerleading programs. Join the Warriors family and build character, teamwork, and lifelong memories through youth sports."
        keywords="Cherokee Youth Football, Canton GA youth sports, K-5 football, youth cheerleading, Cherokee Warriors"
        canonical={`${siteUrl}/`}
        schemaJson={homeSchema}
      />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Hero />
          <Programs />
          {/* <SeasonInfo /> */}
          <UpcomingEvents />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </Suspense>
  );
}
